import { FormattedMessage, useIntl } from "react-intl"
import { SUGGESTIONS } from "../utils"

/**
 * Empty-state suggestions shown on the sourcing landing.
 *
 * Clicking a card pre-fills the search input and immediately runs the search —
 * keeps the "first 30 seconds" experience friction-free.
 */
const SuggestionGrid = ({ onPick }) => {
  const { formatMessage } = useIntl()

  return (
    <div className="sourcing-suggestions">
      <div className="sourcing-suggestions__head">
        <h3>
          <FormattedMessage id="sourcing.suggestions.title" />
        </h3>
        <span className="sourcing-suggestions__hint">
          <FormattedMessage id="sourcing.suggestions.curated" />
        </span>
      </div>

      <div className="sourcing-suggestions__grid">
        {SUGGESTIONS.map(({ tagKey, textKey, queryKey }) => (
          <button
            key={tagKey}
            type="button"
            className="sourcing-suggestion"
            onClick={() => onPick(formatMessage({ id: queryKey }))}
          >
            <span className="sourcing-suggestion__tag">
              <FormattedMessage id={tagKey} />
            </span>
            <p>
              <FormattedMessage id={textKey} />
            </p>
          </button>
        ))}
      </div>
    </div>
  )
}

export default SuggestionGrid
